<template>
  <div class="animated fadeIn">
    <div class="block-screen" v-if="loading"><i class="fa fa-refresh fa-spin"></i></div>
    <b-modal title="Erro!" class="modal-danger" v-model="hasErrors" @ok="hasErrors = false"
      ok-variant="danger" ok-only>
      Verifique todos os campos e tente novamente.
    </b-modal>
    <b-modal title="Info!" class="modal-primary" v-model="notFound" @ok="notFound = false"
      ok-variant="primary" ok-only>
      Usuário não encontrado.
    </b-modal>
    <b-modal title="Info!" class="modal-primary" v-model="emailSended" @ok="emailSended = false"
      ok-variant="primary" ok-only>
      {{updateMessage}}
    </b-modal>
    <b-alert :show="dismissCountDown"
       dismissible
       variant="success"
       @dismissed="dismissCountDown=0"
       @dismiss-count-down="countDownChanged">
      <p>Pedido atualizado com sucesso!</p>
      <b-progress variant="success"
        :max="dismissSecs"
        :value="dismissCountDown"
        height="4px">
      </b-progress>
    </b-alert>
    <b-row>
      <b-col lg="12" v-if="!editOrder && !showGuests">
        <b-card>
          <div slot="header">
            <i class="fa fa-edit"></i> Participante: {{ name }} / CPD: {{ cpd }} / Grupo de Voo: {{ flight  }}
            <b-button variant="default" @click="generateNewPassword()" class="pull-right btn-sm">
              <i class="fa fa-lock"></i>&nbsp; Gerar uma nova senha
            </b-button>
            <b-button variant="default" @click="notify()" class="pull-right btn-sm">
              <i class="fa fa-envelope"></i>&nbsp; Enviar email de registro
            </b-button>
            <b-button variant="default" @click="showGuests = !showGuests" class="pull-right btn-sm">
              <i class="fa fa-users"></i>&nbsp; Visualizar Acompanhantes
            </b-button>
            <span class="pull-right">&nbsp;</span>
            <b-button variant="default" @click="showTickets" class="pull-right btn-sm">
              <i class="fa fa-ticket"></i>&nbsp; Protocolos
            </b-button>
          </div>
          <b-row class="form-group">

            <b-col md="3">
              <b-form-fieldset label="Nome conforme passaporte">
                <b-input-group>
                  <b-form-input type="text" v-model="participant.passportFirstName"
                    :class="{'is-invalid': $v.participant.passportFirstName.$invalid}" maxlength="23">
                  </b-form-input>
                </b-input-group>
              </b-form-fieldset>
            </b-col>
            <b-col md="3">
              <b-form-fieldset label="Sobrenome conforme passaporte">
                <b-input-group>
                  <b-form-input type="text" v-model="participant.passportLastName"
                    :class="{'is-invalid': $v.participant.passportLastName.$invalid}" maxlength="23">
                  </b-form-input>
                </b-input-group>
              </b-form-fieldset>
            </b-col>
            <b-col md="3">
              <b-form-fieldset label="Número do passaporte">
                <b-input-group>
                  <b-form-input type="text" v-model="participant.passportNumber"
                    :class="{'is-invalid': $v.participant.passportNumber.$invalid}" maxlength="23">
                  </b-form-input>
                </b-input-group>
              </b-form-fieldset>
            </b-col>
            <b-col md="3">
              <b-form-fieldset label="Nacionalidade">
                <b-input-group>
                  <b-form-input type="text" v-model="participant.nacionality"
                    :class="{'is-invalid': $v.participant.nacionality.$invalid}" maxlength="23">
                  </b-form-input>
                </b-input-group>
              </b-form-fieldset>
            </b-col>
            <b-col md="3">
              <b-form-fieldset label="País de emissão">
                <b-input-group>
                  <b-form-input type="text" v-model="participant.passportAuthority"
                    :class="{'is-invalid': $v.participant.passportAuthority.$invalid}" maxlength="23">
                  </b-form-input>
                </b-input-group>
              </b-form-fieldset>
            </b-col>
            <b-col md="3">
              <b-form-fieldset label="Validade do passaporte">
                <b-input-group>
                  <b-form-input type="text" v-model="participant.passportValidity" v-mask="'99/99/9999'"
                    :class="{'is-invalid': $v.participant.passportValidity.$invalid}">
                  </b-form-input>
                </b-input-group>
              </b-form-fieldset>
            </b-col>
            <!-- <b-col md="3">
              <b-form-fieldset label="Nome de reconhecimento">
                <b-input-group>
                  <b-form-input type="text" v-model="participant.badgeName"
                    :class="{'is-invalid': $v.participant.badgeName.$invalid}" maxlength="23">
                  </b-form-input>
                </b-input-group>
              </b-form-fieldset>
            </b-col> -->
            <b-col md="3">
              <b-form-fieldset label="Email">
                <b-input-group>
                  <b-form-input type="email" v-model="participant.email"
                    :class="{'is-invalid': $v.participant.email.$invalid}">
                  </b-form-input>
                </b-input-group>
              </b-form-fieldset>
            </b-col>
            <b-col md="3">
              <b-form-fieldset label="CPF">
                <b-input-group>
                  <b-form-input type="text" v-mask="'999.999.999-99'" v-model="participant.cpf"
                    :class="{'is-invalid': $v.participant.cpf.$invalid}">
                  </b-form-input>
                </b-input-group>
              </b-form-fieldset>
            </b-col>
            <b-col md="3">
              <b-form-fieldset label="RG">
                <b-input-group>
                  <b-form-input type="text" v-model="participant.rg"
                    :class="{'is-invalid': $v.participant.rg.$invalid}">
                  </b-form-input>
                </b-input-group>
              </b-form-fieldset>
            </b-col>
            <b-col md="3">
              <b-form-fieldset label="Validade RG">
                <b-input-group>
                  <b-form-input type="text" v-model="participant.validadeRg"
                    :class="{'is-invalid': $v.participant.validadeRg.$invalid}">
                  </b-form-input>
                </b-input-group>
              </b-form-fieldset>
            </b-col>
            <b-col md="3">
              <b-form-fieldset label="Telefone celular">
                <b-input-group>
                  <b-form-input type="text" v-mask="'(99) 99999-9999'" v-model="participant.cellPhone"
                    :class="{'is-invalid': $v.participant.cellPhone.$invalid}">
                  </b-form-input>
                </b-input-group>
              </b-form-fieldset>
            </b-col>
            <b-col md="3">
              <b-form-fieldset label="Data de Nascimento">
                <b-input-group>
                  <b-form-input type="text" v-mask="'99/99/9999'" v-model="participant.dateOfBirth"
                    :class="{'is-invalid': $v.participant.dateOfBirth.$invalid}">
                  </b-form-input>
                </b-input-group>
              </b-form-fieldset>
            </b-col>
            <b-col md="3">
              <b-form-fieldset
                label="Sexo"
                :label-cols="3"
                :horizontal="true">
                <b-form-radio-group style="margin-top: 35px; margin-left: -45px;"
                  v-model="participant.gender"
                  :options="[
                    {text: 'Masculino', value: '1'},
                    {text: 'Feminino', value: '2'},
                  ]"
                  value="1">
                </b-form-radio-group>
              </b-form-fieldset>
            </b-col>
          </b-row>
          <b-row class="form-group">
            <b-col md="3">
              <b-form-fieldset label="Cidade de origem">
                <b-input-group>
                  <b-form-input type="text" v-model="participant.startCity"
                    :class="{'is-invalid': $v.participant.startCity.$invalid}">
                  </b-form-input>
                </b-input-group>
              </b-form-fieldset>
            </b-col>
            <b-col md="3">
              <b-form-fieldset label="Cidade de retorno">
                <b-input-group>
                  <b-form-input type="text" v-model="participant.returnCity"
                    :class="{'is-invalid': $v.participant.returnCity.$invalid}">
                  </b-form-input>
                </b-input-group>
              </b-form-fieldset>
            </b-col>
            <!-- <b-col md="3">
              <b-form-fieldset label="Ponto de Apoio">
                <b-input-group>
                  <b-form-input type="text" v-model="participant.supportPoint"
                    :class="{'is-invalid': $v.participant.supportPoint.$invalid}">
                  </b-form-input>
                </b-input-group>
              </b-form-fieldset>
            </b-col> -->
            <b-col md="3">
              <b-form-fieldset label="Restrição alimentar">
                <b-form-select
                  :plain="true"
                  :options="foods"
                  value="Selecione o tipo"
                  v-model="participant.foodId">
                </b-form-select>
              </b-form-fieldset>
            </b-col>
            <b-col md="3">
              <b-form-fieldset label="Descrição da restrição">
                <b-input-group>
                  <b-form-input type="text" v-model="participant.otherFood">
                  </b-form-input>
                </b-input-group>
              </b-form-fieldset>
            </b-col>
            <b-col md="3">
              <b-form-fieldset label="Necessidades especiais">
                <b-form-select
                  :plain="true"
                  :options="pwdList"
                  value="Selecione o tipo"
                  v-model="participant.pwdId">
                </b-form-select>
              </b-form-fieldset>
            </b-col>
            <b-col md="3">
              <b-form-fieldset label="Descrição da necessidade especial">
                <b-input-group>
                  <b-form-input type="text" v-model="participant.otherPwd">
                  </b-form-input>
                </b-input-group>
              </b-form-fieldset>
            </b-col>
            <!-- <b-col md="3">
              <b-form-fieldset
                label="Não possui visto americano??"
                :label-cols="1"
                :horizontal="false">
                  <b-form-checkbox value="1" v-model="participant.hasVisa">
                  </b-form-checkbox>
              </b-form-fieldset>
            </b-col> -->
            <!-- <b-col md="3" v-if="!participant.hasVisa">
              <b-form-fieldset label="Validade do visto">
                <b-input-group>
                  <b-form-input type="text" v-model="participant.visaValidity" v-mask="'99/99/9999'"
                    :class="{'is-invalid': $v.participant.visaValidity.$invalid}">
                  </b-form-input>
                </b-input-group>
              </b-form-fieldset>
            </b-col> -->
          </b-row>
          <b-row class="form-group">
            <b-col md="3">
              <b-form-fieldset
                label="Não possui passaporte?"
                :label-cols="1"
                :horizontal="false">
                  <b-form-checkbox value="1" v-model="participant.hasPassport">
                  </b-form-checkbox>
              </b-form-fieldset>
            </b-col>
            <!-- <b-col md="3">
              Anexo:
              <b-button variant="default" class="btn-sm" @click="downloadAttachment()">
                <i class="fa fa-download"></i>&nbsp; {{ participant.attachmentName }}
              </b-button>
            </b-col> -->
          </b-row>

          <b-row class="form-group">
            <b-col md="3">
              <b-button variant="default" @click="$router.push({name: 'Participantes'})">
                <i class="fa fa-arrow-left"></i>&nbsp; Voltar
              </b-button>
              <b-button variant="primary" @click="update($v.participant.$invalid, $v.participant.$touch())">
                <i class="fa fa-check"></i>&nbsp; Salvar
              </b-button>
            </b-col>
          </b-row>
        </b-card>
      </b-col><!--/.col-->
      <b-modal id="ticketDialog" size="lg" ok-only
        title="Protocolos">
        <div class="row">
          <div class="col-md-12">
            <b-card>
              <div slot="header">
                <b-row class="form-group">
                  <b-col md="5">
                    <b-form-fieldset label="Observação">
                      <b-input-group>
                        <b-form-textarea :rows="2" :max-rows="3" v-model="obs"
                          placeholder="Aqui você pode deixar uma observação relacionada ao protocolo.">
                        </b-form-textarea>
                      </b-input-group>
                    </b-form-fieldset>
                    <b-button variant="default" class="btn-sm" @click="ticketGenerate">
                      <i class="fa fa-ticket"></i>&nbsp; Gerar Protocolo
                    </b-button>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col lg="12">
                    <c-table striped caption="<i class='fa fa-ticket'></i> Lista de Protocolos"
                      :items="tickets" :fields="fields">
                    </c-table>
                  </b-col>
                </b-row>
              </div>
            </b-card>
          </div>
        </div>
      </b-modal>
    </b-row><!--/.row-->
    <order-list v-if="!showGuests" :participantId="participant.id" :showGuests="showGuests" :editOrder="editOrder"></order-list>
    <order-edit v-if="editOrder" :orderId="currentOrder"></order-edit>
    <guests-list v-if="showGuests" :participantId="participant.id"></guests-list>
  </div>
</template>

<script>

import AwesomeMask from 'awesome-mask'
import { email, maxLength, minLength, required } from 'vuelidate/lib/validators'
import cTable from '../../components/Table.vue'
import Guests from '../../views/guests/List.vue'
import EditOrder from '../../views/orders/Edit.vue'
import Order from '../../views/orders/List.vue'
import * as Helper from './../../methods/helpers'

export default {
  name: 'forms',
  directives: {
    'mask': AwesomeMask
  },
  components: {
    'order-list': Order,
    'order-edit': EditOrder,
    'guests-list': Guests,
    cTable
  },
  data () {
    return {
      name: '',
      cpd: '',
      flight: '',
      foods: [],
      pwdList: [],
      cities: [],
      dismissSecs: 10,
      dismissCountDown: 0,
      showDismissibleAlert: false,
      loading: false,
      hasErrors: false,
      notFound: false,
      emailSended: false,
      updateMessage: '',
      editOrder: false,
      currentOrder: false,
      showGuests: false,
      obs: '',
      participant: {
        id: false,
        badgeName: '',
        email: '',
        cpf: '',
        rg: '',
        validadeRg: '',
        registration: '',
        cellPhone: '',
        dateOfBirth: '',
        gender: '',
        // hasVisa: false,
        // visaValidity: '',
        hasPassport: false,
        confirmInfo: false,
        completed: false,
        foodId: '',
        otherFood: '',
        ptcCount: 0,
        pcd: '',
        attachment_name: '',
        passportFirstName: "",
        passportLastName: "",
        passportNumber: "",
        nacionality: "",
        passportAuthority: "",
        // supportPoint: "",
        // citySupportPoint: ""
      },
      tickets: [],
      fields: [
        {key: 'code', label: 'Protocolo', sortable: true},
        {key: 'observation', label: 'Observação', sortable: true},
        {key: 'name', label: 'Usuário', sortable: true},
        {key: 'created_at', label: 'Criação', sortable: true}
      ],
      userId: false,
    }
  },
  mounted () {
    this.loading = true
    this.$http.get(`sync`)
      .then(response => {
        const data = response.data
        this.cities = data.cities.map(city => {
          return {value: city.id, text: city.name}
        })
        this.foods = data.foods.map(food => {
          return {value: food.id, text: food.name}
        })
        this.pwdList = data.pwd.map(pwd => {
          return {value: pwd.id, text: pwd.name}
        })
      })
    this.userId = this.$router.history.current.params.id
    this.$http.get(`users/${this.userId}`)
      .then(response => {
        const user = response.data.user;
        if (user.completed !== null) {
          this.participant = user.participant;
          this.participant.dateOfBirth = Helper.formatDate(this.participant.dateOfBirth);
          if (this.participant.passportValidity !== null) {
            this.participant.passportValidity = Helper.formatDate(this.participant.passportValidity);
          }
          // if (this.participant && this.participant.visaValidity !== null) {
          //   this.participant.visaValidity = Helper.formatDate(this.participant.visaValidity)
          // }
        } else {
          this.participant.badgeName = user.badgeName
          this.participant.email = user.email
        }
        this.name = user.badgeName
        this.cpd = user.registration
        this.flight = user.participant.flight ? user.participant.flight.flight.group_number : 'Sem grupo de vôo selecionado'
        this.loading = false
        if (this.$router.history.current.params.guests === true) {
          this.showGuests = true
        }
        if (this.$router.history.current.params.updatedGuest === true) {
          this.updatedGuest = true
        }
        let uri = window.location.toString()
        if (uri.indexOf('/true/true') > 0) {
          let cleanUri = uri.substring(0, uri.indexOf('/true/true'))
          window.history.replaceState({}, document.title, cleanUri)
        }
        this.$router.history.current.params.guests = false
        this.$router.history.current.params.updatedGuest = false
      })
      .catch((error) => {
        console.error(error)
        this.notFound = true
        this.loading = false
      })
  },
  methods: {
    ticketGenerate () {
      this.loading = true

      const data = { observation: this.obs, user_id: this.userId }

      this.$http.post(`tickets`, data)
        .then(response => {
          this.obs = ''
        })
        .finally(() => {
          this.showTickets()
        })
    },
    showTickets () {
      this.loading = true
      this.$http.get(`tickets/${this.userId}`)
        .then(response => {
          this.tickets = response.data.tickets.map(ticket => {
            ticket.name = ticket.user.badge_name
            return ticket
          })
        })
        .finally(() => {
          this.loading = false
          this.$root.$emit('bv::show::modal', `ticketDialog`)
        })
    },
    update (isInvalid, touched) {
      if (isInvalid === false) {
        this.loading = true
        let participant = this.participant

        // if (participant.hasVisa) {
        //   participant.visaValidity = null
        // }
        this.$http.post(`participants`, participant)
          .then(response => {
            this.participant.id = response.data.participant.id
            this.loading = false
            this.$router.push({name: 'Participantes', params: {updated: true}})
          })
          .catch(response => {
            this.hasErrors = true
            this.loading = false
          })
      }
    },
    countDownChanged (dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert () {
      this.dismissCountDown = this.dismissSecs
    },
    notify() {
      this.loading = true;
      this.$http.post(`users/notify`, {id: [this.userId]})
        .then(response => {

          this.loading = false;
          this.emailSended = true;
          switch (response.data.status[0].status) {
            case 'success':
              this.updateMessage = 'Email enviado com sucesso!';
              break;
            case 'already_sent':
              this.updateMessage = 'Email já enviado previamente';
              break;

            default:
              this.updateMessage = response.data.status[0].status;
              break;
          }
        })
        .catch(error => {
          console.error(error)
          this.loading = false
        })
    },
    generateNewPassword() {
      this.loading = true;
      this.$http.post(`users/generate-new-pwd`, {id: this.userId})
        .then(response => {
          this.loading = false;
          this.emailSended = true;
          this.updateMessage = `Senha nova: ${response.data.pwd}`;
        })
        .catch(error => {
          console.error(error)
          this.loading = false
        })
    },
    downloadAttachment () {
      this.loading = true;
      this.$http.get(`participants/${this.participant.id}/attachment`)
      .then(response => {
        const linkSource = `data:image/*;base64,${response.data.attachment_binary}`;
        const downloadLink = document.createElement('a');
        document.body.appendChild(downloadLink);

        downloadLink.href = linkSource;
        downloadLink.target = '_self';
        downloadLink.download = this.participant.attachmentName;
        downloadLink.click();
        this.loading = false;
      })
      .catch((error) => {
        console.error(error);
        this.notFound = true;
        this.loading = false;
      })
    }
  },
  validations () {
    return {
      participant: {
        email: { required, email, maxLength: maxLength(150) },
        // badgeName: { required, maxLength: maxLength(23) },
        cpf: { required, minLength: minLength(14), maxLength: maxLength(14) },
        rg: { minLength: minLength(6), maxLength: maxLength(18) },
        validadeRg: { required, minLength: minLength(10), maxLength: maxLength(10) },
        registration: { required, maxLength: maxLength(150) },
        cellPhone: { required, minLength: minLength(14) },
        dateOfBirth: {
          required,
          minLength: minLength(10),
          isValidDate: function (value) {
            return Helper.isValidDate(value, true)
          }
        },
        gender: {required},
        startCity: {required},
        returnCity: { required },
        // supportPoint: { required },
        // citySupportPoint: { required },
        // ptcCount: { required },
        // visaValidity: !this.participant.hasVisa ? {
        //   required,
        //   minLength: minLength(10),
        //   isValidDate: function (value) {
        //     return Helper.isValidDate(value)
        //   }
        // } : {},
        passportFirstName: !this.participant.hasPassport ? { required }: {},
        passportLastName: !this.participant.hasPassport ? { required }: {},
        passportNumber: !this.participant.hasPassport ? { required }: {},
        nacionality: { required },
        passportAuthority: !this.participant.hasPassport ? { required }: {},
        passportValidity: !this.participant.hasPassport ? { required }: {},
      }
    }
  }
}
</script>

<style>
  .modal-lg {
    max-width: 1000px;
  }
</style>



// WEBPACK FOOTER //
// src/views/participants/Edit.vue